import { type CommonErrorResponses as LinkCommonErrorResponses } from '../links/CommonErrorResponses';
import { type CreateStoreProblem as SchemaCreateStoreProblem } from '../schemas/CreateStoreProblem';
import { type CreateStoreResponseBody as SchemaCreateStoreResponseBody } from '../schemas/CreateStoreResponseBody';
import { type DraftLiteStore as SchemaDraftLiteStore } from '../schemas/DraftLiteStore';

/**
 * ‼️ Файл сформирован автоматически. Не редактировать вручную.
 *
 */
export const CreateLiteStoreContentType = 'application/json' as const;
export type CreateLiteStoreRequest = SchemaDraftLiteStore;
export type CreateLiteStoreResponses = LinkCommonErrorResponses & {
    /**
     * @description Successful workflow creation
     */
    '200': {
        'application/json': SchemaCreateStoreResponseBody;
    };
    /**
     * @description Bad store creation request
     */
    '400': {
        'application/json': SchemaCreateStoreProblem;
    };
    /**
     * @description Unauthorized user
     */
    '401': {
        'application/json': SchemaCreateStoreProblem;
    };
};
export type CreateLiteStoreResponseSuccess = CreateLiteStoreResponses['200']['application/json'];
export type CreateLiteStoreSearchParams = undefined;
export type CreateLiteStorePathParameters = undefined;
export const CreateLiteStoreUrl = '/stores/lite' as const;
export const CreateLiteStoreMethod = 'POST' as const;
export const getCreateLiteStoreUrl = (_params?: CreateLiteStorePathParameters) => CreateLiteStoreUrl;
